<script>
import FormService from "../services/FormService";
import mapValidationRules from "../utils/map-validation-rules";

export default {
  name: "LocaleFormProvider",
  data() {
    return {
      form: {},
      locales: [
        { id: "en", name: "English" }
      ],
      activeLocale: "en",
      rtl: false
    };
  },
  props: {
    webformId: {
      type: String,
      default: "Default"
    },
    defaultLang: {
      type: String,
      default: "en"
    }
  },
  computed: {
    currentLocale: {
      get() {
        return this.activeLocale;
      },
      async set(selectedValue) {
        if (selectedValue === this.activeLocale) {
          return;
        }
        this.activeLocale = selectedValue;
        this.rtl = ["ar", "he", "fa", "ur", "sd"].includes(selectedValue);
        this.$store.commit("setLocale", { activeLocale: this.activeLocale, rtl: this.rtl });

        const form = await FormService.getForm(this.webformId, selectedValue);
        this.form = form;
        this.$store.commit("setForm", { ...form, webformId: this.webformId });
        this.$emit("validations", this.getValidationRules());
        this.updateIconAndTitle();
      },
    },
  },
  methods: {
    getValidationRules() {
      return mapValidationRules(this.form.validations);
    },
    updateIconAndTitle() {
      if (this.form.favicon) {
        const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "icon";
        const baseHref = (document.querySelector("base") || {}).href || "/";
        link.href = `${baseHref}${this.form.favicon.replace(/^\//, "")}`;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
      if (this.form.title) {
        document.title = this.form.title;
      }
    }
  },
  async created() {
    const form = await FormService.getDefaultForm(this.webformId);
    this.form = form;
    this.$store.commit("setForm", { ...form, webformId: this.webformId });
    this.$emit("validations", this.getValidationRules());
    if (this.form.logo) {
      this.$store.commit("setLogo", this.form.logo);
    }
    if (!this.form.includePreviousFormValues) {
      this.$store.commit("clearPrevious");
      this.$store.commit("clearCurrent");
    } else {
      // Redirect back to landing page
      const previousFormModel = this.$store.state.formModel;
      if (!previousFormModel || Object.keys(this.$store.state.formModel).length === 0) {
        const langCode = this.$store.state.activeLocale || "en";
        await this.$router.push(`/webform/${this.form.includePreviousFormValues}/${langCode}`);
        return;
      }
    }
    this.updateIconAndTitle();
    this.locales = this.form.locales;
    // is the path param one of the supported locales?
    if (this.locales.some(({ id }) => this.defaultLang === id)) {
      this.currentLocale = this.defaultLang;
      return;
    }
    // is the browser language one of the supported params?
    const lang = navigator.language.slice(0, 2);
    if (this.locales.some(({ id }) => lang === id)) {
      this.currentLocale = lang;
    }
  },
  render(createElement) {
    return createElement("div", {}, this.$scopedSlots.default({
      currentLocale: this.currentLocale,
      locales: this.locales,
      form: this.form,
      rtl: this.rtl,
      setLocale: value => {
        this.currentLocale = value;
        this.$router.replace({
          name: "webform",
          params: { webformId: this.webformId, lang: value }
        });
      }
    }));
  }
};
</script>
